import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Footer from '../common/Footer';
import StoreNavbar from './StoreNavbar';

const StoreLayout = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  /**
   * Handle user logout
   * @returns {Promise<void>}
   */
  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/');

      // Clear cart data on logout
      localStorage.removeItem('cartItems');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <StoreNavbar user={user} handleLogout={handleLogout} />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default StoreLayout;
